import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {changeSurveyStatus} from "../../../../slices/surveysSlice";
import {removeSurveyFromListById} from "../../../../slices/surveysSlice";
import SurveysService from "../../../../services/SurveysService";
import DeleteSurveyModal from "../../modals/DeleteSurveyModal";
import {withToastManager} from "react-toast-notifications";

function SurveyCard(props){
	const dispatch = useDispatch();
    const {survey, numberOfRespondents} = props;
    const {questTitle, questStatus, dateOfCreation, lastModified} = survey;
    const [statusIsChanging, setStatusIsChanging] = useState(false);

	const [shouldShowDeleteModal, setShouldShowDeleteModal] = useState(false);
	const [isSurveyBeingDeleted, setIsSurveyBeingDeleted] = useState(false);

	const actionText = questStatus === "ACTIVE" ? "STOP" : "START";
	const actionClassName = "surveys__list__item__action surveys__list__item__action--" + actionText.toLowerCase();
	let statusClassName = "surveys__list__item surveys__list__item--draft";
	if(questStatus === "ACTIVE" || questStatus === "CLOSED") statusClassName = "surveys__list__item surveys__list__item--" + questStatus.toLowerCase();

    function gotToBuilderPage(){
        props.history.push("/survey/builder/" + props.survey.questId);
    }

    function gotToChartsPage(){
        props.history.push("/survey/reports/" + props.survey.questId);
    }

    function goToSharePage(){
        props.history.push("/survey/share/" + props.survey.questId)
    }

    function handleClickChangeStatus(){
        if(statusIsChanging) return;
		const nextStatus = questStatus === "ACTIVE" ? "CLOSED" : "ACTIVE";
        setStatusIsChanging(true);
		SurveysService.ChangeSurveyStatus(props.survey.questId, nextStatus,
            (success1) => {
				dispatch(changeSurveyStatus({id:props.survey.questId,status:nextStatus}));
                setStatusIsChanging(false);
			},
            (error1) => {
                setStatusIsChanging(false);
            }
		);
    }

    function deleteSurvey(questId){

        setIsSurveyBeingDeleted(true);
        SurveysService.deleteSurveyById(questId,
            (success) => {
                setIsSurveyBeingDeleted(false);
                setShouldShowDeleteModal(false);
                dispatch(removeSurveyFromListById({questId : questId}));
            },
            (error) => {
                props.toastManager.add("Could not delete survey.", {
                    appearance: 'error'
                });
                setIsSurveyBeingDeleted(false);
                setShouldShowDeleteModal(false);
            }
        );
    }

    function openDeleteModal(){
        setShouldShowDeleteModal(true);
    }

    function closeDeleteModal(){
        setShouldShowDeleteModal(false);
    }

    return (
        <div className={statusClassName}>
            <div className="surveys__list__item__status">
                <span className="surveys__list__item__status__bubble"></span>
                <span className="surveys__list__item__status__text">{questStatus}</span>
            </div>
            <div className={actionClassName}>
                <a href="#" onClick={(event) => {event.preventDefault();handleClickChangeStatus()}}>
                    <span className="surveys__list__item__action__icon"></span>
                    <span className="surveys__list__item__action__text">{actionText}</span>
                </a>
            </div>
            <div className="surveys__list__item__title">{questTitle}</div>
            <div className="surveys__list__item__details">
                <div className="surveys__list__item__details__row">
                    <span>Respondents</span>
                    <span>{numberOfRespondents}</span>
                </div>
                <div className="surveys__list__item__details__row">
                    <span>Created</span>
                    <span>{dateOfCreation}</span>
                </div>
                <div className="surveys__list__item__details__row">
                    <span>Last modified</span>
                    <span>{lastModified}</span>
                </div>
            </div>
            <div className="surveys__list__item__footer">
                <div className="surveys__list__item__footer__item">
                    <span className="tooltiptext">Edit</span>
                    <a className="surveys__list__item__footer__item__edit" href="#" onClick={(event) => {event.preventDefault();gotToBuilderPage()}}></a>
                </div>
                <div className="surveys__list__item__footer__item">
                    <span className="tooltiptext">Share</span>
                    <a className="surveys__list__item__footer__item__launch" href="#" onClick={(event) => {event.preventDefault();goToSharePage()}}></a>
                </div>
                <div className="surveys__list__item__footer__item">
                    <span className="tooltiptext">Reports</span>
                    <a className="surveys__list__item__footer__item__chart" href="#" onClick={(event) => {event.preventDefault();gotToChartsPage()}}></a>
                </div>
                <div className="surveys__list__item__footer__item">
                    <span className="tooltiptext">Delete</span>
                    <a className="surveys__list__item__footer__item__delete" onClick={(event) => {event.preventDefault();openDeleteModal()}}></a>
                </div>
            </div>
            <DeleteSurveyModal
                survey={props.survey}
                deleteSurvey={deleteSurvey}
                closeModal={closeDeleteModal}
                modalShown={shouldShowDeleteModal}
                isSurveyBeingDeleted={isSurveyBeingDeleted}
            />
        </div>
    );
}

export default withToastManager(SurveyCard);